import React, { useState, useEffect, useContext } from "react";
import * as api from "../../api";
import { CurrentRepair, RepairHistory, RepairStatusField } from "../../models/Repair/Repair";
import { RouteComponentProps } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CancelModelRepair from "../Modal/CancelModelRepair";
import { clearMediaFiles, isMediaResume, resumeDraftRepair, selectedWorkorderForMedia, showMenuTabs, showFooter, userChosenAdditionalDescription, userChosenAdditionalDescriptionCOUNT, userChosenContactDetails, userChosenContactName, userChosenContactPhone, userChosenCovidQuestion, userChosenEmergencyQuestion, userChosenHighLevelDescription, userChosenIsReporter, userChosenPropertyAddress, userChosenPropertyId, userChosenPropertyType, userChosenRelationDetails, userChosenRepairLocation, userChosenRepairLocationId, userChosenSOR, userChosenSupplementaryQuestions, userChosenUPRN, userChosenVandalismAdditionalInformation, userChosenVandalismQuestion, userChosenVulnerabilityAdditionalInformation, userChosenVulnerabilityQuestion, userCreatedNewRepair, userResumeData, userResumeDraftDataCache, repairPriorityValue, userGetRepairData, userChosenDuplicateQuestion, DMCChecksavedAnswer, dmcRepairSorCodeValues, dmcInspectionSorCodeValues, saveEmailCopyRadioValue, saveAlternateEmailValue, selectedTenancyGroup } from "../../ducks/redux/actions/userChoices";
import { RepairPriority, ContractorRepairPriority } from "../../models/Repair/CreateRepair";
import { FeatureFlags } from "../contexts/FeatureFlags";
import { getHeatingHotWaterCase, getMaintResp, getRepairResp, saveCustomerphoneNumber, selectedTenacyType, workOrderRepairObject, getDeterminedContractorDetails, saveSupplimentaryCodes, saveAssociatedAssests } from "../../ducks/redux/actions/getAddress";
import { isNullOrUndefined } from "../../utils/formatting";
import { trackException } from "../../appInsights/TelemetryService";
import { eligibilityResponseObject, fetchRepairReasons, fetchRepairReasonsSelect, resumeRepairReasonPriorityUpdatedToEmergency, selectedRepairReasonPriorityDetermination, updateDashboardForm } from "../../ducks/redux/actions/dashboardReducer.actions";
import { repairHistoryData } from "../../ducks/redux/actions/historicRepair";
import Button from "../../storybook/Button";
import Message from "../../storybook/Message";
import Chevronleft from "../../assets/img/Chevronleft.png";
import mobileChevronleft from "../../assets/img/mobileChevronleft.png";
import MediaList from "../MediaList/index"
import ReScheduleModelRepair from "../Modal/ReScheduleModelRepair";
import ListingDetailHeader from "../../storybook/Header/ListingDetailHeader";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import { CustomerResponse } from "../../models/Customer";
import { generateErrorMessage } from "../../utils/NullCheck";
import { detectMobile } from "../../utils/formatting";
import { saveDMCAnswers } from "../../ducks/redux/actions/FinancialReferral";
import { EMAContractorType } from "../../models/Repair/Contractor";
import LoadingSpinner from "../../storybook/LoadingSpinner";

interface RepairHistoryDetailsProps extends RouteComponentProps<any> {
  Appointment?: string;
  Priority?: string;
  Contractor?: string;
  Description?: string;
  workOrderID?: string;
  status?: string;
  repairReference?: string;
  area?: string;
  fullDescription?: string;
  appointmentDate?: string;
  ContractorsList?: string[];
  siteIdentifier?: string;
  associtaedAsset?: string;
}

const RepairHistoryDetails: React.FC<RepairHistoryDetailsProps> = (props) => {
  let moment = require("moment");
  const dispatch = useDispatch();
  let contractorSiteIdentifer = "";
  const isMobile = detectMobile();

  //#region  "page state"


  const [repairHistoryDetails, setRepairHistoryDetails] = React.useState<
    RepairHistory[]
  >([]);


  const [mostRecentStatus, setMostRecentStatus] = useState("");
  const [mostRecentStatusClass, setMostRecentStatusClass] = useState("");
  const [mostRecentStatusMobileClass, setmostRecentStatusMobileClass] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const [isAppointmentAvailable, setIsAppointmentAvailable] = useState("none");
  const [isCancelButton, setIsCancelButton] = useState("none");
  const [isRescheduleButton, setIsRescheduleButton] = useState("none");
  const [isRescheduleShow, setIsRescheduleShow] = useState("none");
  const [errorCode, setErrorCode] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [errorCodeReschedule, setErrorCodeReschedule] = React.useState("");
  const [contractorContactNumber, setContractorContactNumber] = useState("");
  const { featureMedia }: any = useContext(FeatureFlags);
  const [rescheduleMessage, setRescheduleMessage] = useState("");
  const [draftRepair, setDraftRepair] = useState<any>();
  const [contractorSitesIdentifierValue, setContractorSitesIdentifierValue] = useState("");
  const [isMedia, setIsMedia] = useState(false);
  const [communalToggle, setCommunalToggle] = useState("true");
  const customerID = useSelector((state: any) => state?.addresses?.customerid);
  const [mediaOwner, setMediaOwner] = useState(customerID);
  const _customerId = localStorage.getItem("customerId") || "";
  const [isActive, setIsActive] = React.useState(false);
  const [isReScheduleModal, setIsReScheduleModalShow] = useState(false);

  const [appointmentStartDate, setAppointmentStartDate] = useState("");
  const [isSelectAppointmentChosen, setIsSelectAppointmentChosen] = useState(false);
  const [woHadDemobilizedContractorSite, setWOHadDemobilizedContractorSite] = useState(false);
  const [contractorDetails, setContractorDetails] = useState<any>(null);
  const [errorAPIFailure, setErrorAPIFailure] = useState(false);
  const [isWorkOrderAPIFailure, setIsWorkOrderAPIFailure] = useState('');
  const [isHistorySectionAPIFailure, setIsHistorySectionAPIFailure] = useState('');
  const [isCancelEligibilityAPIFailure, setIsCancelEligibilityAPIFailure] = useState('');
  const [isRescheduleEligibilityAPIFailure, setIsRescheduleEligibilityAPIFailure] = useState('');
  const [PriorityResponseValue, setPriorityResponseValue] = useState("");

  let isIntegrated = false;

  //#endregion "state"

  //#region "selectors"
  const repairHistoryDataValue = useSelector(
    (state: any) => state?.historicRepairReducer?.repairHistoryData
  );

  const contractorphone = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenContactPhone
  );
  const contractorname = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenContactName
  );


  const isCatalyst = useSelector(
    (state: any) => state?.userChoicesReducer?.isCatalystCustomer
  );

  const customerResponse: CustomerResponse = useSelector(
    (state: any) => state?.addresses?.saveCustomerDetails
  );

  const demobilizedContractorList = useSelector(
    (state: any) => state?.userChoicesReducer?.demobilizedContractorSites
  );
  const dmcInspectionSorCodes = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues
  );
  const repairSorCodeValues = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcRepairSorCodeValues
  );

  const [assetPremisesType, setAssetPremisesType] = useState("");
  //#endregion "selectors"

  //#region "functions" 

  const backButtonHandler = () => {
    dispatch(showMenuTabs(true));
    props.history.goBack();
  };

  const selectAppointmentHandler = () => {
    setIsSelectAppointmentChosen(true);
    dispatch(userGetRepairData(draftRepair));
    if (!woHadDemobilizedContractorSite) {
      props.history.push("/appointmentscheduler");
    }
  };

  function getRepairStatus(status: string, filteredItems: any[], t: (key: string) => string) {
    if (status === RepairStatusField.ReportedToEMA) {
      return t("ReportedToEMA_Title");
    } else if (status === RepairStatusField.AssignedtoManagingAgent || status === RepairStatusField.CatalystEMATriage) {
      return t("PassedtoPeabody");
    } else if (filteredItems?.length > 0) {
      return filteredItems[0]?.statusTitle;
    }
    return "Draft";
  }

  const setupRepaiHistoryDetails = async (workOrderId: string | undefined) => {
    try {
      setIsActive(!isActive);
      if (!isActive) {
        if (workOrderId == null) {
          setErrorAPIFailure(true);
          setIsWorkOrderAPIFailure("WorkOrderByIdAPI_Error");
        }
        else {
          try {
            //const workOrderResponse = await api.getWorkOrder(workOrderId);
            const workOrderResponse = await api.getRepair(workOrderId);
            setAssetPremisesType(workOrderResponse?.area === "Block" || workOrderResponse?.area === "Estate" ||
              workOrderResponse?.area === "Divided Block" || workOrderResponse?.area === "Divided block" ? "Communal" : workOrderResponse?.area)
            setWOHadDemobilizedContractorSite(demobilizedContractorList?.some((x: string) => x.toLowerCase() === workOrderResponse?.contractor?.toLowerCase()));
            setDraftRepair(workOrderResponse);
            setMediaOwner(workOrderResponse?.customerIdentifier);
            dispatch(userChosenHighLevelDescription(workOrderResponse?.description));
            // === Adding view media button condition ===  
            const assetType = workOrderResponse?.premisesType
            const assetId = workOrderResponse?.assetIdentifier;
            dispatch(
              updateDashboardForm({
                assetType,
                assetId,
                customerID,
              })
            );
            const addressesData = await api.getAssociatedAssets(workOrderResponse?.assetIdentifier);
            dispatch(saveAssociatedAssests([addressesData]));
            if (workOrderResponse?.documents?.documentIdentifiers?.length > 0) {
              setIsMedia(true);
            } else {
              setIsMedia(false);
            }
            // Retriving dmc data here
            if (workOrderResponse?.assessmentInformation?.supplementaryQuestionResponses ?? false) {
              // Reading supplementaryQuestionResponses and saving in store for future use
              const supplementaryResponsesObject: { [key: string]: any } = {};
              workOrderResponse?.assessmentInformation?.supplementaryQuestionResponses?.forEach(
                (response: any) => {
                  supplementaryResponsesObject[response.questionId] = Array.isArray(response.responseId) ? response.responseId : [response.responseId];
                }
              );
              dispatch(saveDMCAnswers(supplementaryResponsesObject));
            }
            // Storing DMCAssesment value for resume workorder
            if (workOrderResponse?.isCausingDampAndMould) {
              if ((dmcInspectionSorCodes?.includes(workOrderResponse?.sorCode) || repairSorCodeValues?.includes(workOrderResponse?.sorCode))) {
                dispatch(DMCChecksavedAnswer("No"));
              }
              else {
                dispatch(DMCChecksavedAnswer("Yes"));
              }
              // Adding preferences coming from get wo by id
              if (workOrderResponse?.assessmentInformation?.communicationPreference?.preferenceType === "email") {
                if (workOrderResponse?.assessmentInformation?.communicationPreference?.addresses?.digitalAddresses[0]?.address === customerResponse?.addresses?.digitalAddresses[0]?.address) {
                  dispatch(saveEmailCopyRadioValue(customerResponse?.addresses?.digitalAddresses[0]?.address));
                } else {
                  dispatch(saveAlternateEmailValue(workOrderResponse?.assessmentInformation?.communicationPreference?.addresses?.digitalAddresses[0]?.address))
                }
              }
            }
            else {
              dispatch(DMCChecksavedAnswer(""));
            }
            // === end ===  
            const _customerId = localStorage.getItem("customerId") || "";
            if (workOrderResponse != null) {
              contractorSiteIdentifer = workOrderResponse?.contractor || "";

              if (contractorSiteIdentifer) {
                const isKnownEmaTriage =
                  contractorSiteIdentifer !== EMAContractorType.UNKNOWN_EMA_TRIAGE &&
                  contractorSiteIdentifer !== EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE;


                if (isKnownEmaTriage) {
                  const area = repairHistoryDataValue?.RepairHistoryarea ?? "";
                  const isCommunal = area === "Block" || area === "Estate" || area === "Divided block";
                  const premiseType = isCommunal ? "Communal" : area;

                  //get repairReason 
                  const repairReasonResponsedata: any = await getRepairReasons(workOrderResponse, premiseType, isCatalyst);
                  const repairReasonElement = repairReasonResponsedata?.[0]?.element;

                  //fetch asset details
                  const assetData = await fetchAssetDetails(workOrderResponse?.assetIdentifier)
                  const maintsResp =
                    assetData?.maintenanceResponsibilities?.find(
                      (resp: any) => resp.type === "MAINTSRESP"
                    )?.value ?? "";
                  const repairResp =
                    assetData?.maintenanceResponsibilities?.find(
                      (resp: any) => resp.type === repairReasonElement
                    )?.value ?? "";
                  dispatch(getMaintResp(maintsResp));
                  dispatch(getRepairResp(repairResp));

                  const contractorDetails = await api.getContractorBySiteIdentifier(contractorSiteIdentifer);

                  if (!isNullOrUndefined(contractorDetails?.[0]) && workOrderResponse?.contractorName) {
                    contractorDetails[0].name = workOrderResponse?.contractorName
                  }
                  setContractorDetails(contractorDetails?.[0] ?? null);
                  dispatch(getDeterminedContractorDetails(contractorDetails?.[0]));
                  setContractorContactNumber(contractorDetails?.[0]?.contacts?.[0]?.addresses?.digitalAddresses?.[0]?.telecomsAddresses?.[0]?.number ?? workOrderResponse?.contractorPhoneNumber ?? "");

                  setContractorSitesIdentifierValue(contractorSiteIdentifer);
                  setAppointmentStartDate(workOrderResponse.appointmentStartDate);
                  isIntegrated = contractorDetails?.[0]?.statuses?.isIntegrated;

                  if (dmcInspectionSorCodes.includes(workOrderResponse.sorCode)) {
                    if (([ContractorRepairPriority.DampAndMould,
                    ContractorRepairPriority.DampAndMouldLow,
                    ContractorRepairPriority.DampAndMouldMedium] as string[]).includes(workOrderResponse.repairPriority) && !workOrderResponse?.isPendingAssessment) {
                      if (workOrderResponse.status === RepairStatusField.Cancelled || workOrderResponse.status === RepairStatusField.Appointed) {
                        setIsAppointmentAvailable("none");
                      } else {
                        setIsAppointmentAvailable("inline");
                      }
                      setIsRescheduleButton("none");
                    }
                    else {
                      await reschedule(workOrderResponse, _customerId, isIntegrated, contractorDetails?.[0]);
                      setIsAppointmentAvailable("none");
                    }
                  } else {
                    if (
                      (isIntegrated &&
                        workOrderResponse.area === "Property" &&
                        workOrderResponse.priority === RepairPriority.NextAvailable &&
                        workOrderResponse.status === RepairStatusField.Unappointed)
                    ) {
                      setIsAppointmentAvailable("inline");
                      setIsRescheduleButton("none");
                    }
                    else {
                      //get reschedule eligibility
                      await reschedule(workOrderResponse, _customerId, isIntegrated, contractorDetails?.[0]);
                      setIsAppointmentAvailable("none");
                    }
                  }
                }
                else {
                  setContractorSitesIdentifierValue(contractorSiteIdentifer);
                  setAppointmentStartDate(workOrderResponse.appointmentStartDate);
                }
              }
              //get cancel repair eligibility
              try {
                const eligibilityResponse = await api.getCancelRepairEligibility(
                  (workOrderResponse.reportingMethod = "CustomerSelfService"),
                  workOrderResponse.status,
                  workOrderResponse.isDraft,
                  workOrderResponse.isEmergency,
                  workOrderResponse.isOutOfHours,
                  workOrderResponse.isRecall ?? false,
                  workOrderResponse.isEMA,
                  workOrderResponse.isPotentialDuplicate,
                  workOrderResponse.contractor,
                  workOrderResponse.repairLocation,
                  workOrderResponse.trade,
                  workOrderResponse.sorCode,
                  moment(new Date(workOrderResponse.raisedDate)).format(
                    "yyyy-MM-DD"
                  ),
                  repairHistoryDataValue.RepairHistoryarea || "",
                  workOrderResponse?.appointmentStartDate,
                  _customerId,
                  workOrderResponse?.customerIdentifier
                );

                if (eligibilityResponse.isEligible) {
                  setIsCancelButton("inline");
                  if (eligibilityResponse.errorCode === "") {
                    setErrorCode("SSR036");
                    setIsCancelButton("inline");
                  } else {
                    setIsCancelButton("none");
                    setErrorCode(eligibilityResponse.errorCode);
                    setCancelMessages(eligibilityResponse.errorCode)
                  }
                } else {
                  setErrorCode("SSR036");
                  setIsCancelButton("none");
                }
              }
              catch (e: any) {
                if (isWorkOrderAPIFailure === "")
                  setErrorAPIFailure(true);
                setIsCancelEligibilityAPIFailure("EligibilityCancelAPI_Error");
              }
            }
          }
          catch (e: any) {
            setErrorAPIFailure(true);
            setIsWorkOrderAPIFailure("WorkOrderByIdAPI_Error");
          }

          //Scroll to top of current repair detail parent element if returning to Historic Repairs Details Page
          if (!isNullOrUndefined(repairHistoryDataValue?.repairHistoryOperation)) {
            const isMobileView = document.getElementById('scrollableDiv')?.offsetParent != null,
              parentHTMLBody = isMobileView ? document.getElementById('scrollableDiv') : document.getElementById('paginationDiv'),
              repairDivIdQuery = "#Repair_Id_" + workOrderId,
              repairDiv = parentHTMLBody?.querySelector(repairDivIdQuery) as HTMLElement | null;
            repairDiv?.scrollIntoView();
            dispatch(repairHistoryData(""));
          }

        }
      }
    } catch (e: any) {
      const _channel = process.env.REACT_APP_X_CHANNEL_IDENTIFIER;
      const _customerId = localStorage.getItem("customerId") || "";
      const _corelationId = localStorage.getItem("corelationId") || "";
      trackException(e, _channel, _customerId, _corelationId);
      console.error(e);
      setErrorAPIFailure(true);
      setIsWorkOrderAPIFailure("WorkOrderByIdAPI_Error");
    }
  };


  const reschedule = async (
    workOrderResponse: CurrentRepair,
    _customerId: string,
    isIntegrated: boolean,
    contractorData: any
  ) => {
    try {
      const eligibilityResponse = await api.getRescheduleEligibility(
        (workOrderResponse.reportingMethod = "CustomerSelfService"),
        workOrderResponse.id,
        workOrderResponse.status,
        workOrderResponse.isDraft,
        workOrderResponse.isEmergency,
        workOrderResponse.isOutOfHours,
        workOrderResponse.isRecall ?? false,
        workOrderResponse.isEMA,
        workOrderResponse.isPotentialDuplicate,
        workOrderResponse.contractor,
        workOrderResponse.repairLocation,
        workOrderResponse.trade,
        workOrderResponse.sorCode,
        moment(new Date(workOrderResponse.raisedDate)).format("yyyy-MM-DD"),
        repairHistoryDataValue.RepairHistoryarea || "",
        workOrderResponse?.appointmentStartDate == null
          ? ""
          : moment(new Date(workOrderResponse?.appointmentStartDate)).format(
            "yyyy-MM-DD"
          ),

        _customerId,
        workOrderResponse?.customerIdentifier,
        isIntegrated,
        workOrderResponse?.lastAppointmentCreatedDate == null
          ? ""
          : moment(workOrderResponse?.lastAppointmentCreatedDate).format(
            "yyyy-MM-DD"
          ),
      );

      if (workOrderResponse.status !== RepairStatusField.Appointed) {
        setIsRescheduleButton("none");
      }
      else if (eligibilityResponse.isEligible) {

        setErrorCodeReschedule(eligibilityResponse.errorCode);
        //setAppointmentStartDate(workOrderResponse.appointmentStartDate);
        //setAppointmentEndDate(workOrderResponse.appointmentEndDate);
        if (eligibilityResponse.errorCode.toString() === "SSR071" || eligibilityResponse.errorCode.toString() === "SSR075") {
          let message = t(eligibilityResponse.errorCode);
          message = message.replace("{0}", contractorData?.name ?? "");
          message = message.replace("{1}", contractorData?.contacts?.[0]?.addresses?.digitalAddresses?.[0]
            ?.telecomsAddresses?.[0]?.number ?? "");
          setRescheduleMessage(message);
          setIsRescheduleButton("none");
          setIsRescheduleShow("inline")
        }
        else if (eligibilityResponse.errorCode.toString() === "SSR070") {
          const message = t("SSR070");
          setRescheduleMessage(message);
          setIsRescheduleButton("none");
          setIsRescheduleShow("inline")
        }
        else {
          if (isNullOrUndefined(eligibilityResponse.errorCode)) {
            setIsRescheduleShow("none");
            setIsRescheduleButton("inline");
            return;
          }
        }
      } else {
        setIsRescheduleButton("none");
      }
    }
    catch (e: any) {
      if (isWorkOrderAPIFailure === "")
        setErrorAPIFailure(true);
      setIsRescheduleEligibilityAPIFailure("EligibilityRescheduleAPI_Error");
    }

  };

  const getRepairReasons = async (draftRepair: any, premiseType: any, isCatalyst: any) => {
    const responseData = await api.searchRepairReasons(draftRepair?.repairReason, premiseType, isCatalyst);

    return responseData;
  }
  const resumeRepairHandler = async (wid: any) => {
    dispatch(showMenuTabs(false));
    dispatch(showFooter(false));
    dispatch(resumeDraftRepair(true));
    dispatch(clearMediaFiles([]));
    dispatch(isMediaResume(true));
    const responsedata = await api.searchRepairReasons(
      draftRepair?.description,
      assetPremisesType,
      isCatalyst
    );
    dispatch(fetchRepairReasonsSelect(responsedata));
    const extractedReasons: string[] = [];
    responsedata.forEach((eachData, key) => {
      const { description } = eachData;
      extractedReasons.push(description);
    });
    dispatch(fetchRepairReasons(extractedReasons));
    // IF area is Property and SorCode PROMOULD and Repair isDraft Then resume repair
    const area = repairHistoryDataValue?.RepairHistoryarea ?? "";
    const premiseType =
      area === "Block" ||
        area === "Estate" ||
        area === "Divided block"
        ? "Communal"
        : area;
    if (area === 'Property'
      && repairSorCodeValues?.includes(draftRepair?.sorCode)
      && draftRepair.repairReason === 'Damp or mould repair required') {
      draftRepair.sorCode = t('Investigate_DM_SorCode');
      draftRepair.originalWorkOrderSorCode = t('Investigate_DM_SorCode');
      draftRepair.repairReason = "Inspect Damp and Mould";
      draftRepair.description = "Inspect Damp and Mould";
    }

    let assetrResponse = null;
    dispatch(
      saveCustomerphoneNumber(customerResponse?.addresses?.telecomsAddresses)
    );
    dispatch(
      saveCustomerphoneNumber(customerResponse?.addresses?.telecomsAddresses))
    dispatch(userChosenIsReporter(draftRepair?.reporterToBeContacted));
    if (draftRepair?.reporterContactDetails != null) {
      const name = draftRepair.reporterContactDetails?.name?.givenName?.replace(/\b(null|undefined)\b/g, "").trim();
      dispatch(userChosenContactPhone(draftRepair.reporterContactDetails.contactNumber))
      dispatch(userChosenContactName(name))
      dispatch(userChosenRelationDetails(draftRepair.reportedBy));
      dispatch(userChosenContactDetails("I would like to provide number for this repair."));

      draftRepair.reporterContactDetails.name = null;
    }
    else {
      //dispatch(userChosenContactDetails(draftRepair.co));
      dispatch(userChosenRelationDetails("Customer"));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactDetails(customerResponse?.addresses?.telecomsAddresses?.[0]?.number));
      dispatch(
        userChosenContactDetails(
          customerResponse?.addresses?.telecomsAddresses?.[0]?.number
        )
      );

    }


    /*** This fetches the High Level, Supplementary Question and Repair Emergency Data ***/

    const repairReasonResponsedata: any = await getRepairReasons(draftRepair?.repairReason, premiseType, isCatalyst);
    let selectedReason = repairReasonResponsedata?.filter(
      (reason: any) => reason.description === draftRepair.description
    ) ?? [];

    const selectedReason0 = selectedReason?.[0];
    const isContractorEMA = draftRepair?.isEMA ? "Y" : "N"
    const raisedFormattedDate = moment(new Date()).format("YYYY-MM-DDTHH:mm:ss");

    //to keep up the sorcode change for total loss of water
    const responseTenancyGroup = await api.getTenanciesGroup(draftRepair?.customerIdentifier, draftRepair?.premisesId);
    const tenancyGroup = responseTenancyGroup?.[0]?.tenancyGroup || "";
    const responsePremisesEligibility = await api.postPremisesEligibility(
      draftRepair.premisesId,
      tenancyGroup
    );
    const supplementaryCodes = responsePremisesEligibility?.[0]?.supplimentaryCodes || "";
    dispatch(selectedTenancyGroup(responseTenancyGroup?.[0]?.tenancyGroup))
    dispatch(saveSupplimentaryCodes(supplementaryCodes));

    const isSupplementaryCode = selectedReason0?.description === "Total loss of water" && supplementaryCodes?.includes("FISPUMPS02");
    const sorCodeUpdated = isSupplementaryCode ? "COMPUMP" : draftRepair.originalWorkOrderSorCode
    draftRepair.sorCode = sorCodeUpdated
    draftRepair.originalWorkOrderSorCode = sorCodeUpdated
    // Adding isANATypes for customer preferences
    let isAnaTypeValue = false;
    if (customerResponse?.preferences?.length > 0) {
      isAnaTypeValue = customerResponse?.preferences?.some((additionalNeedAlert: any) => additionalNeedAlert.preference.type === 'additionalNeeds');
    }
    let tenureCode = "";
    if (customerResponse?.tenanciesSummaries?.length > 1) {
      const tenancySummary = customerResponse?.tenanciesSummaries?.filter(
        (tenancy: any) =>
          tenancy?.tenancySummary?.tenancyEndDate === null
      );
      tenureCode = tenancySummary?.[0]?.tenancySummary?.tenancyTenureCode ?? "";
    }
    else {
      tenureCode = customerResponse?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode ?? "";
    }
    const isV14Upgradable = selectedReason0?.isV14Upgradable || false;
    /*** This fetches the Updated Seasonal Priority for mapped Repair reasons from Drools ***/
    const priorityDeterminationResponse = (await api.postRepairPriority({
      repairType: draftRepair.sorCode,
      isEmergency: draftRepair.isEmergency,
      isRecall: draftRepair.isRecall,
      isEMA: isContractorEMA,
      isVulnerable: draftRepair.isVulnerable,
      description: draftRepair.description,
      raisedDate: raisedFormattedDate,
      isAnaType: isAnaTypeValue,
      isV14Upgradable: isV14Upgradable,
      channel: RepairChannel.CustomerSelfService,
      tenureCode: tenureCode,
      workProgramme: draftRepair?.workProgramme || '',
      premisesType: draftRepair?.premisesType || ''
    }))?.repairPriority;

    dispatch(repairPriorityValue(priorityDeterminationResponse));
    setPriorityResponseValue(priorityDeterminationResponse);

    const nextAvailablePriorities: ContractorRepairPriority[] = [
      ContractorRepairPriority.NextAvailable,
      ContractorRepairPriority.DampAndMouldLow,
      ContractorRepairPriority.DampAndMouldMedium,
      ContractorRepairPriority.DampAndMould
    ];

    const isNextAvailablePriority =
      nextAvailablePriorities.includes(
        priorityDeterminationResponse as ContractorRepairPriority
      );

    let priorityValue: RepairPriority | null = null;

    if (priorityDeterminationResponse === ContractorRepairPriority.Emergency) {
      priorityValue = RepairPriority.Emergency;
    } else if (isNextAvailablePriority) {
      priorityValue = RepairPriority.NextAvailable;
    }

    const repairReasonPriorityIsUpdated = priorityValue != null && priorityValue !== draftRepair.priority;
    dispatch(selectedRepairReasonPriorityDetermination(draftRepair.priority));
    dispatch(resumeRepairReasonPriorityUpdatedToEmergency(repairReasonPriorityIsUpdated && priorityValue === RepairPriority.Emergency));
    draftRepair.isDraft = null;

    if (draftRepair.sorCode === "NA") {
      dispatch(getHeatingHotWaterCase("E32"));
    }
    dispatch(workOrderRepairObject(draftRepair));
    dispatch(userCreatedNewRepair(draftRepair));
    const {
      premisesId,
      repairLocationId,
      repairLocation,
      repairReason,
      isSupplementary,
      isEmergency,
      additionalInformation,
      isVandalism,
      crimeReferenceNumber,
      isVulnerable,
      VulnerableResponseText,
      isCovidSelfIsolated,
      reporterContactDetails,
      premisesUniqueReference,
    } = draftRepair;

    // const area = props?.area != undefined ? props?.area : "";

    if (repairHistoryDataValue?.RepairHistoryassocitaedAsset != null) {
      assetrResponse = await fetchAssetDetails(premisesId);
      dispatch(eligibilityResponseObject(assetrResponse));
      let maintsResp =
        assetrResponse?.maintenanceResponsibilities?.find(
          (resp: any) => resp.type === "MAINTSRESP"
        )?.value ?? "";
      let repairResp =
        assetrResponse?.maintenanceResponsibilities?.find(
          (resp: any) => resp.type === selectedReason0?.element
        )?.value ?? "";
      dispatch(userChosenPropertyId(assetrResponse?.id));
      dispatch(getMaintResp(maintsResp));
      dispatch(getRepairResp(repairResp));
    }


    if (assetrResponse?.addresses?.postalAddresses?.[0]?.formattedAddress != null) {
      dispatch(userChosenPropertyAddress(assetrResponse?.addresses?.postalAddresses?.[0]?.formattedAddress));
    }

    dispatch(selectedTenacyType(area));

    if (selectedReason0?.additionalData?.length && selectedReason0?.additionalData?.[0]?.description != "") {
      const resumeData = {
        resumeHLRepair: selectedReason0?.description,
        resumeHLSubQuestion: selectedReason0?.additionalData?.[0]?.description,
        resumeSelectedProperty: area,
        resumePriority: repairReasonPriorityIsUpdated ? priorityValue : draftRepair.priority,
      };
      dispatch(userResumeData(resumeData));
    } else {
      const resumeData = {
        resumeHLRepair: "",
        resumeHLSubQuestion: "",
        resumeSelectedProperty: area,
        resumePriority: repairReasonPriorityIsUpdated ? priorityValue : draftRepair.priority,
      };
      dispatch(userResumeData(resumeData));
    }


    if (selectedReason0?.priority === "Emergency") {
      dispatch(userChosenEmergencyQuestion(draftRepair.isEmergency ? t("Repair_Emergency_Radio1_Text") : t("Repair_Emergency_Radio2_Text")));
    }
    dispatch(userChosenDuplicateQuestion(draftRepair.isPotentialDuplicate === true ? t("duplicateNoneofTheAbove") : ""));
    dispatch(userChosenPropertyId(premisesId));
    dispatch(userChosenPropertyType(area));
    dispatch(userChosenUPRN(premisesUniqueReference));
    dispatch(userChosenSOR(sorCodeUpdated));

    repairLocation &&
      dispatch(userChosenRepairLocation(repairLocation)) &&
      dispatch(userChosenRepairLocationId(repairLocationId));
    repairReason && dispatch(userChosenHighLevelDescription(repairReason));
    isSupplementary === true
      ? dispatch(userChosenSupplementaryQuestions("Yes"))
      : isSupplementary === false
        ? dispatch(userChosenSupplementaryQuestions("No"))
        : dispatch(userChosenSupplementaryQuestions(""));
    additionalInformation &&
      dispatch(userChosenAdditionalDescription(t(additionalInformation))) &&
      dispatch(
        userChosenAdditionalDescriptionCOUNT(additionalInformation.length)
      );
    isVandalism
      ? dispatch(userChosenVandalismQuestion("Yes")) &&
      dispatch(userChosenVandalismAdditionalInformation(crimeReferenceNumber))
      : dispatch(userChosenVandalismQuestion("No"));
    isVulnerable
      ? dispatch(userChosenVulnerabilityQuestion("Yes")) &&
      dispatch(
        userChosenVulnerabilityAdditionalInformation(VulnerableResponseText)
      )
      : dispatch(userChosenVulnerabilityQuestion("No"));
    isCovidSelfIsolated === true
      ? dispatch(userChosenCovidQuestion("Yes"))
      : isCovidSelfIsolated === false
        ? dispatch(userChosenCovidQuestion("No"))
        : dispatch(userChosenCovidQuestion(""));
    const resumeDraftDataCache = {
      repairLocation,
      repairLocationId,
      repairReason,
      supplementaryQuestions:
        isSupplementary === true
          ? "Yes"
          : isSupplementary === false
            ? "No"
            : "",
      emergencyQuestion: isEmergency && t("Repair_Emergency_Radio1_Text"),
      additionalInformation,
      vandalismQuestion: isVandalism ? "Yes" : "No",
      crimeReferenceNumber: isVandalism ? crimeReferenceNumber : "",
      vulnerabilityQuestion: isVulnerable ? "Yes" : "No",

      vulnerableResponseText: isVulnerable ? VulnerableResponseText : "",
      covidQuestion:
        isCovidSelfIsolated === true
          ? "Yes"
          : isCovidSelfIsolated === false
            ? "No"
            : "",
      reporterContactDetails,
    };
    dispatch(userResumeDraftDataCache(resumeDraftDataCache));
    if (featureMedia === "false") {
      if (draftRepair?.reporterContactDetails != null) {
        const name = draftRepair.reporterContactDetails?.name?.trim();
        dispatch(
          userChosenContactPhone(
            draftRepair.reporterContactDetails.contactNumber
          )
        );
        dispatch(userChosenContactName(name));
        dispatch(userChosenRelationDetails(draftRepair.reportedBy));
        dispatch(
          userChosenContactDetails(
            "I would like to provide number for this repair."
          )
        );
      } else {
        //dispatch(userChosenContactDetails(draftRepair.co));
        dispatch(userChosenRelationDetails("Customer"));
        dispatch(
          userChosenContactPhone(
            customerResponse?.addresses?.telecomsAddresses?.[0]?.number
          )
        );
        dispatch(
          userChosenContactDetails(
            customerResponse?.addresses?.telecomsAddresses?.[0]?.number
          )
        );
      }
    }
    props.history.push("/repairlocation");
  };
  const fetchAssetDetails = async (id: string) => {
    try {
      const assetData = await api.getAssetsByid(id);
      dispatch(eligibilityResponseObject(assetData));
      return assetData;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const rescheduleAppointmentHandler = () => {
    if (errorCodeReschedule === "CR166") {
      setIsReScheduleModalShow(true);
      return;
    } else {
      setIsReScheduleModalShow(false);
    }
    if (isRescheduleShow === "Block") {
      setIsRescheduleShow("none");
    }
    else {
      if (errorCodeReschedule === "SSR071" || errorCodeReschedule === "SSR075") {
        let message = t(errorCodeReschedule);
        message = message.replace("{0}", contractorname);
        message = message.replace("{1}", contractorphone);
        setRescheduleMessage(message);
      }
      else if (errorCodeReschedule === "SSR070") {
        const message = t("SSR070");
        setRescheduleMessage(message);
      }
      else {
        if (!isNullOrUndefined(errorCodeReschedule)) {
          setIsRescheduleShow("Block");
          return;
        }
        const historyData = CreateHistoryData("RescheduleAppointment");
        dispatch(repairHistoryData(historyData));
        dispatch(userGetRepairData(draftRepair));
        props.history.push("/appointmentscheduler");
      }
      setIsRescheduleShow("Block");
    }
  }

  const CreateHistoryData = (operation: string) => {
    return {
      repairHistoryOperation: operation,
      repairHistoryWorkOrderID: repairHistoryDataValue.RepairHistoryworkOrderID,
      repairHistoryContractor: repairHistoryDataValue.RepairHistoryContractor,
      repairHistoryContractorSitesIdentifier: contractorSitesIdentifierValue,
      repairHistoryWorkProgramme: repairHistoryDataValue.repairHistoryWorkProgramme || ""
    };
  };

  const setCancelMessages = (error: string) => {
    if (error === "SSR036") {
      seterrorMessage(t("SSR036i"))
    }
    else if (error === "SSR066") {
      seterrorMessage(t("SSR066ii"))
    }
    else if (error === "SSR008") {
      seterrorMessage(t("SSR008ii"))
    }
  }

  //#endregion


  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const dmcInspectionSorCodes = await api.GetAppConfigToggleValue("dmcInspectionSorCodes");
        const dmcRepairSorCodes = await api.GetAppConfigToggleValue("dmcRepairSorCodes");
        if (dmcInspectionSorCodes.length === 0) {
          const dmcInspectionSorCode = await api.GetAppConfigToggleValue("dmcInspectionSorCodes");
          // You may want to use dmcInspectionSorCode here or dispatch it to the store if needed
          dispatch(dmcInspectionSorCodeValues(dmcInspectionSorCode?.value));
        }
        if (repairSorCodeValues.length === 0) {
          const repairSorCode = await api.GetAppConfigToggleValue("dmcRepairSorCodes");
          // You may want to use repairSorCode here or dispatch it to the store if needed
          dispatch(dmcRepairSorCodeValues(repairSorCode?.value));
        }

        dispatch(dmcInspectionSorCodeValues(dmcInspectionSorCodes?.value));
        dispatch(dmcRepairSorCodeValues(dmcRepairSorCodes?.value));
        //logic for buttons 
        const workOrderId = repairHistoryDataValue?.repairHistoryWorkOrderID;
        dispatch(selectedWorkorderForMedia(workOrderId));
        const results = await Promise.all([
          setupRepaiHistoryDetails(workOrderId),
          api.getRepairHistories(workOrderId)
        ]);
        //end logic for buttons
        const allItems: any = [];
        const repairHistory: any = results[1];
        repairHistory?.map((eachItem: any) => {
          const emergencyStatus =
            repairHistoryDataValue.repairHistoryPriority === "Emergency" ||
              repairHistoryDataValue.repairHistoryPriority ===
              "Emergency (Out of hours)"
              ? true
              : false;
          const appointmentDate =
            eachItem.appointmentStartDatetime
              ? moment(
                eachItem.appointmentStartDatetime
              ).format("MMMM Do YYYY, h:mm:ss A")
              : "";

          let APCREATE01_Comment_Formatted = t("APCREATE01_Comment");
          APCREATE01_Comment_Formatted = APCREATE01_Comment_Formatted.replace("{0}", eachItem.appointmentStartDatetime ? moment.utc(eachItem.appointmentStartDatetime).format("MMMM Do YYYY") : "")
            .replace("{1}", eachItem.appointmentStartDatetime ? moment.utc(eachItem.appointmentStartDatetime).format("h:mm A") : "")
            .replace("{2}", eachItem.appointmentEndDatetime ? moment.utc(eachItem.appointmentEndDatetime).format("h:mm A") : "");

          const allItemsObj: any = {
             "Pending Assessment": {
              statusTitle: t("Repair complete"),
              comments: t("Completed_Comment"),
            },
            Unappointed: {
              statusTitle: t("Unappointed_Title"),
              comments: emergencyStatus
                ? t("Unappointed_Comment_Emergency")
                : t("Unappointed_Comment"),
            },
            Appointed: {
              statusTitle: t("Appointed_Title"),
              comments: `${t("Appointed_Comment")} ${appointmentDate}`,
            },
            APCREATE01: {
              statusTitle: t("APCREATE01_Title"),
              comments: `${APCREATE01_Comment_Formatted}`,
            },
            APCREATE10: {
              statusTitle: t("APCREATE10_Title"),
              comments: `${t("APCREATE10_Comment1")}`,
            },
            AUPDATE01: {
              statusTitle: t("AUPDATE01_Title"),
              comments: `${t("AUPDATE01_Comment1")} ${appointmentDate}. ${t(
                "AUPDATE01_Comment2"
              )}`,
            },
            AUPDATE02: {
              statusTitle: t("AUPDATE02_Title"),
              comments: `${t("AUPDATE02_Comment1")} ${appointmentDate}. ${t(
                "AUPDATE02_Comment2"
              )}`,
            },
            AUPDATE03: {
              statusTitle: t("AUPDATE03_Title"),
              comments: `${t("AUPDATE03_Comment1")} ${appointmentDate}. ${t(
                "AUPDATE03_Comment2"
              )}`,
            },
            AUPDATE05: {
              statusTitle: t("AUPDATE05_Title"),
              comments: `${t("AUPDATE05_Comment1")} ${appointmentDate}. ${t(
                "AUPDATE05_Comment2"
              )}`,
            },
            AUPDATE06: {
              statusTitle: t("AUPDATE06_Title"),
              comments: `${t("AUPDATE06_Comment1")} ${appointmentDate}. ${t(
                "AUPDATE06_Comment2"
              )}`,
            },
            AUPDATE07: {
              statusTitle: t("AUPDATE07_Title"),
              comments: `${t("AUPDATE07_Comment1")} ${appointmentDate}. ${t(
                "AUPDATE07_Comment2"
              )}`,
            },
            NOACCESS: {
              statusTitle: t("NOACCESS_Title"),
              comments: t("NOACCESS_Comment"),
            },
            ENGOS01: {
              statusTitle: t("ENGOS01_Title"),
              comments: t("ENGOS01_Comment"),
            },
            ENGOS03: {
              statusTitle: t("ENGOS03_Title"),
              comments: t("ENGOS03_Comment"),
            },
            NOACC01: {
              statusTitle: t("NOACC01_Title"),
              comments: t("NOACC01_Comment"),
            },
            ENGOS05: {
              statusTitle: t("ENGOS05_Title"),
              comments: t("ENGOS05_Comment"),
            },
            ENGOS06: {
              statusTitle: t("ENGOS06_Title"),
              comments: t("ENGOS06_Comment"),
            },
            ENGOS07: {
              statusTitle: t("ENGOS07_Title"),
              comments: t("ENGOS07_Comment"),
            },
            Completed: {
              statusTitle: t("Completed_Title"),
              comments: t("Completed_Comment"),
            },
            Cancelled: {
              statusTitle: t("Cancelled_Title"),
              comments: t("Cancelled_Comment"),
            },
          };



          const itemObject = {
            statusTitle:
              allItemsObj[eachItem.identifier]?.statusTitle || "",
            comments: allItemsObj[eachItem.identifier]?.comments || "",
            createDateTime: eachItem.createDateTime,
          };
          if (eachItem.subType !== "WorkOrder") {
            allItems.push(itemObject);
          }
        });
        const filteredItems = allItems.filter(
          (item: any) => item.statusTitle !== ""
        );

        const repairStatus = getRepairStatus(
          repairHistoryDataValue.RepairHistorystatus,
          filteredItems,
          t
        );
        setMostRecentStatus(repairHistoryDataValue.RepairHistorystatus === 'On Hold' ? 'On Hold' :
          repairStatus);
        setMostRecentStatusClass(
          filteredItems[0]?.statusTitle === "Repair cancelled" ? "status-style-red" :
            filteredItems[0]?.statusTitle === "Repair completed" ? "status-style-green" :
              "status-style-yellow"
        )
        setmostRecentStatusMobileClass(
          filteredItems[0]?.statusTitle === "Repair cancelled" ? "mobile-repaircreate-red" :
            filteredItems[0]?.statusTitle === "Repair completed" ? "mobile-repaircreate-green" :
              "mobile-repaircreate-yellow"
        )
        setRepairHistoryDetails(filteredItems);

        //set media section data

      } catch (e) {
        if (isWorkOrderAPIFailure === "") {
          setErrorAPIFailure(true);
          setIsHistorySectionAPIFailure("RepairDetailsHistoryAPI_Error");
          setmostRecentStatusMobileClass("mobile-repaircreate-yellow");
        }
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);


  const setContractorName = () => {
    const contractorSiteIdentifier =
      contractorSitesIdentifierValue ??
      repairHistoryDataValue?.RepairHistoryContractorSitesIdentifier ??
      "";

    if (
      contractorSiteIdentifier === EMAContractorType.CATALYST_TRIAGE_EMA ||
      contractorSiteIdentifier === EMAContractorType.UNKNOWN_EMA_TRIAGE ||
      contractorSiteIdentifier === EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE
    ) {
      return "Managing Agent";
    }

    const contractorName = contractorDetails?.name;
    if (contractorName) {
      return contractorName;
    }

    if (repairHistoryDataValue?.RepairHistoryContractor) {
      return repairHistoryDataValue.RepairHistoryContractor;
    }

    if (repairHistoryDataValue?.RepairHistoryrepairReference) {
      return t("contractor_unknown");
    }

    return "-";
  };

  const contractorSiteIdentifier =
    contractorSitesIdentifierValue ||
    repairHistoryDataValue?.RepairHistoryContractorSitesIdentifier ||
    "";

  const isUnknownEMADummyWorkOrder =
    contractorSiteIdentifier === EMAContractorType.UNKNOWN_EMA_TRIAGE ||
    contractorSiteIdentifier === EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE;

  const canResumeRepair =
    repairHistoryDataValue?.RepairHistorystatus === RepairStatusField.InDiagnosis &&
    !isUnknownEMADummyWorkOrder;

  return (
    <>
      {!isNullOrUndefined(repairHistoryDataValue) && <ListingDetailHeader name={"Listing"}></ListingDetailHeader>}

      {/* Red Alert */}
      {(isWorkOrderAPIFailure && errorAPIFailure) ? <div data-testid="alert-warning" className={isMobile ? "px-3" : ""}>
        <Message className="error-msg">
          {generateErrorMessage(t(isWorkOrderAPIFailure))}
        </Message>
      </div> :
        <div role="main" className="position-relative padding-repair mobile-view">
          {isLoading ? (
            <div className="text-center">
              <LoadingSpinner />
            </div>
          ) : (
            <>

              {/* buttons section  */}
              <div
                id="hisRepDet-main-btn"
                className="appoint-btn appoint-desktop"
              >
                {canResumeRepair ? (
                  <Button
                    className="primary-btn"
                    data-testid="btn_Resume_repair"
                    id="hisRepDet-btn1"
                    onClick={resumeRepairHandler}
                  >
                    {t("Resume_repair")}
                  </Button>
                ) : (
                  <><span style={{ display: isCancelButton }}>
                    <CancelModelRepair
                      id="repreason-exitmodal"
                      workOrderId={repairHistoryDataValue.RepairHistoryworkOrderID}
                      area={repairHistoryDataValue.RepairHistoryarea}
                      errorCode={errorCode}
                      props={props} />
                  </span><span style={{ display: isAppointmentAvailable }}>

                      <Button
                        className="primary-btn"
                        data-testid="btn_Select_Appointment"
                        id="hisRepDet-btn3"
                        onClick={selectAppointmentHandler}
                      >
                        {t("Select_Appointment")}
                      </Button>
                    </span><span style={{ display: isRescheduleButton }}>
                      <Button
                        data-testid="btn_Reschedule"
                        id="hisRepDet-btn4"
                        className="primary-btn"
                        onKeyDown={rescheduleAppointmentHandler}
                        onClick={rescheduleAppointmentHandler}
                      >
                        {t("Reschedule_Appointment")}
                      </Button>
                    </span></>
                )}
              </div>


              <div className={mostRecentStatusMobileClass}>
                <h2 className="rephistory-heading d-inline">
                  <span id="backmodal-p" className="back-page">
                    <a data-testid="btn_back_repair" className="back-btn" onClick={backButtonHandler}>
                      <img src={Chevronleft} className="large-leftarrow" alt="Filter" />
                      <img src={mobileChevronleft}
                        className="small-leftarrow detail-backarrow"
                        alt="Filter" />
                    </a>
                  </span>
                  {repairHistoryDataValue.RepairHistoryrepairReference}
                </h2>

                <span className={mostRecentStatusClass}>
                  {repairHistoryDataValue.RepairHistorystatus === "In Diagnosis" ? "Draft" : mostRecentStatus}
                </span>

              </div>

              {/* buttons section  */}
              <div
                id="hisRepDet-main-btn"
                className="appoint-btn appoint-mobile"
              >
                {canResumeRepair ? (
                  <Button
                    className="primary-btn"
                    data-testid="btn_Resume_repair"
                    id="hisRepDet-btn1"
                    onClick={resumeRepairHandler}
                  >
                    {t("Resume_repair")}
                  </Button>
                ) : (
                  <>

                    <span style={{ display: isAppointmentAvailable }}>

                      <Button
                        className="primary-btn"
                        data-testid="btn_Select_Appointment"
                        id="hisRepDet-btn3"
                        onClick={selectAppointmentHandler}
                      >
                        {t("Select_Appointment")}
                      </Button>
                    </span>
                    <span style={{ display: isRescheduleButton }}>

                      <Button
                        data-testid="btn_Reschedule"
                        id="hisRepDet-btn4"
                        className="primary-btn"
                        onKeyDown={rescheduleAppointmentHandler}
                        onClick={rescheduleAppointmentHandler}
                      >
                        {t("Reschedule_Appointment")}
                      </Button>
                    </span>
                    <span style={{ display: isCancelButton }}>
                      <CancelModelRepair
                        id="repreason-exitmodal"
                        workOrderId={repairHistoryDataValue.RepairHistoryworkOrderID}
                        area={repairHistoryDataValue.RepairHistoryarea}
                        errorCode={errorCode}
                        props={props}
                      />
                    </span>
                  </>
                )}
              </div>
              {/* Red Alert */}
              {isCancelEligibilityAPIFailure && errorAPIFailure && repairHistoryDataValue.RepairHistorystatus !== "In Diagnosis" &&
                <div data-testid="alert-warning" className={isMobile ? "px-3" : ""}>
                  <Message className="error-msg">
                    {generateErrorMessage(t(isCancelEligibilityAPIFailure))}
                  </Message>
                </div>}
              {isRescheduleEligibilityAPIFailure && errorAPIFailure && repairHistoryDataValue.RepairHistorystatus !== "In Diagnosis" &&
                <div data-testid="alert-warning" className={isMobile ? "px-3" : ""}>
                  <Message className="error-msg">
                    {generateErrorMessage(t(isRescheduleEligibilityAPIFailure))}
                  </Message>
                </div>}

              <div className="row repair-details padding-repair">
                {isReScheduleModal && (
                  <ReScheduleModelRepair
                    setIsReScheduleModalShow={setIsReScheduleModalShow}
                  />
                )}

                {
                  repairHistoryDataValue.RepairHistoryContractor === 'ContractorSiteOnHold' &&
                  (
                    <p id='onHoldRepairMsg'>
                      <Message className='info-msg'>
                        {t('onHoldRepairHistoryDetailsMessage')}
                      </Message>
                    </p>
                  )
                }


                {isSelectAppointmentChosen && woHadDemobilizedContractorSite && (<p id="warningMsg">
                  <Message className="warning-msg">
                    <div>{t("please_contact")} {contractorDetails?.name} {t("on_phone")} {contractorContactNumber} {t("book_appointment")}</div>
                  </Message>
                </p>)
                }

                {
                  errorMessage !== "" && errorCode !== "" && (
                    <p id="cancelMsg">
                      <Message className="info-msg">
                        {errorMessage}
                      </Message>

                    </p>)

                }

                {rescheduleMessage && <div className="p-0" style={{ display: isRescheduleShow }}>
                  <p id="resheduleMsg">
                    <Message className="info-msg">
                      {rescheduleMessage}
                    </Message>
                  </p>
                </div>}

                <div className="col-md-6 col-sm-12 descr-padding">
                  <h6 className="pb-6">{t("historic_repairs_description")}</h6>
                  <p className="pb-12">{repairHistoryDataValue.RepairHistoryDescription}</p>
                  <h6 className="pb-6">{t("historic_repairs_dates")}</h6>
                  <p className="pb-12">{repairHistoryDataValue.RepairHistoryRaisedDate}</p>

                  <h6 className="pb-6">{t("historic_repairs_area")}</h6>
                  <p className="pb-12">{repairHistoryDataValue.RepairHistoryarea}</p>
                </div>
                <div className="col-md-6 appoint-section">
                  <h5>{t("historic_repairs_appointment")}
                  </h5>
                  <h6 className="pb-6">{t("historic_repairs_appointment")}</h6>
                  <p className="pb-12">
                    {(appointmentStartDate?.length > 0) ? moment(appointmentStartDate).format('DD-MM-YYYY, h.mma') : "-"}
                  </p>

                  <h6 className="pb-6">{t("historic_repairs_priority")}</h6>
                  <p className="pb-12">{PriorityResponseValue || repairHistoryDataValue?.RepairHistoryPriority}</p>
                  <h6 className="pb-6">{t("historic_repairs_contractor")}</h6>
                  <p className="pb-12">{setContractorName()}</p>


                </div>
              </div>

              <div className="history-section padding-repair">
                <h5>
                  {t("History")}
                </h5>
                {(isHistorySectionAPIFailure && errorAPIFailure) ? (
                  <div data-testid="alert-warning">
                    <Message className="error-msg">
                      {generateErrorMessage(t(isHistorySectionAPIFailure))}
                    </Message>
                  </div>
                ) : (
                  <>
                    {repairHistoryDetails?.length && mostRecentStatus ? (
                      <p>
                        <Message className="info-msg">{t("SSR072")}</Message>
                      </p>
                    ) : (
                      <p className="pb-7">{t("repairs_history_no_results")}</p>
                    )}
                    {repairHistoryDetails.map(
                      (eachRepairUpdate: RepairHistory, key: any) => {
                        return (
                          <div key={key}>
                            <h6 className="pb-7">{eachRepairUpdate.statusTitle}</h6>
                            <p> {eachRepairUpdate.comments} </p>
                            <p className="repaircreate-date">
                              {moment(eachRepairUpdate.createDateTime).format(
                                "MMMM Do YYYY, h:mm:ss A"
                              )}
                            </p>
                          </div>
                        );
                      }
                    )}
                  </>
                )}
              </div>
              {isMedia && communalToggle === "true" && (
                <div className="row history-section padding-repair">
                  <div className="col-md-12 media-section">
                    <MediaList
                      wOid={repairHistoryDataValue.repairHistoryWorkOrderID}
                      {...props}
                    ></MediaList>
                  </div>
                </div>
              )}

              {isMedia &&
                communalToggle === "false" &&
                _customerId === mediaOwner && (
                  <div className="row history-section padding-repair">
                    <div className="col-md-12 media-section">
                      <MediaList
                        wOid={repairHistoryDataValue.repairHistoryWorkOrderID}
                        {...props}
                      ></MediaList>
                    </div>
                  </div>
                )}

            </>
          )}
        </div>
      }
    </>
  );
};
export default RepairHistoryDetails;